module.exports = __webpack_public_path__ + "63d4c25263ef927801181c20bec4f13d.png";